module.exports = __webpack_public_path__ + "img/Type_Flying.9820f487.png";